import { useMemo } from "react";
import intl from "react-intl-universal";
import {
  TbChartBar,
  TbCreditCard,
  TbCurrencyDollar,
  TbScale,
  TbShield,
  TbTrendingUp,
} from "react-icons/tb";
import { SummaryCard } from "../../../../../Components/Atoms/SummaryCard";
import { formatMonetaryValue } from "../../../../../Utils/formatters";
import { BAAS_CARTOES_CREDITO_HASH } from "../../constants";
import { EMPTY_BAAS_HOME_CREDIT_METRICS } from "../baasHomeMetrics";

const formatPercent = (value, fractionDigits = 1) =>
  `${new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)}%`;

export const BaasCreditoKpiCards = ({
  titleKey = "baas.home.creditSection",
  metrics = null,
} = {}) => {
  const creditMetrics = useMemo(
    () => metrics || EMPTY_BAAS_HOME_CREDIT_METRICS,
    [metrics],
  );
  const currency = creditMetrics.currency || "BRL";

  const formatMoney = (value) =>
    formatMonetaryValue(value, currency, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const creditSection = useMemo(
    () => [
      {
        key: "totalLimit",
        icon: TbCurrencyDollar,
        title: intl.get("baas.home.totalLimit.title"),
        value: formatMoney(creditMetrics.totalLimitBrl),
        subtext: intl.get("baas.home.totalLimit.subtext"),
      },
      {
        key: "runningCredit",
        icon: TbTrendingUp,
        title: intl.get("baas.home.runningCredit.title"),
        value: formatMoney(creditMetrics.runningCreditBrl),
        subtext: intl.get("baas.home.runningCredit.subtext"),
      },
      {
        key: "utilization",
        icon: TbChartBar,
        title: intl.get("baas.home.utilization.title"),
        value: formatPercent(creditMetrics.utilizationRate, 0),
        subtext: intl.get("baas.home.utilization.subtext"),
      },
      {
        key: "unsecuredCredit",
        icon: TbCreditCard,
        title: intl.get("baas.home.unsecuredCredit.title"),
        value: formatPercent(creditMetrics.unsecuredRate, 0),
        subtext: intl.get("baas.home.unsecuredCredit.subtext"),
      },
      {
        key: "collateralizedCredit",
        icon: TbShield,
        title: intl.get("baas.home.collateralizedCredit.title"),
        value: formatPercent(creditMetrics.collateralizedRate, 0),
        subtext: intl.get("baas.home.collateralizedCredit.subtext"),
      },
      {
        key: "netExposure",
        icon: TbScale,
        title: intl.get("baas.home.netExposure.title"),
        value: formatMoney(creditMetrics.netExposureBrl),
        subtext: intl.get("baas.home.netExposure.subtext"),
      },
    ],
    [creditMetrics, currency],
  );

  return (
    <section id={BAAS_CARTOES_CREDITO_HASH} className="min-w-0 w-full scroll-mt-4">
      <p className="dashboard-section-label mb-3">{intl.get(titleKey)}</p>
      <div className="dashboard-card-grid">
        {creditSection.map((card) => (
          <SummaryCard
            key={card.key}
            icon={card.icon}
            title={card.title}
            value={card.value}
            footerLabel={card.subtext}
          />
        ))}
      </div>
    </section>
  );
};
